import en from '../locales/en.json';
import bn from '../locales/bn.json';
import hi from '../locales/hi.json';

// Supported languages configuration
export const SUPPORTED_LANGUAGES = {
  en: { name: 'English', nativeName: 'English', flag: '🇬🇧' },
  bn: { name: 'Bengali', nativeName: 'বাংলা', flag: '🇧🇩' },
  hi: { name: 'Hindi', nativeName: 'हिंदी', flag: '🇮🇳' },
};

// Translation resources
export const resources = {
  en: { translation: en },
  bn: { translation: bn },
  hi: { translation: hi },
};

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Get supported language codes
export const getSupportedLanguageCodes = () => Object.keys(SUPPORTED_LANGUAGES);

// Get supported languages with metadata
export const getSupportedLanguagesWithMetadata = () => 
  Object.entries(SUPPORTED_LANGUAGES).map(([code, data]) => ({
    code,
    ...data,
  }));

// Language storage key
export const LANGUAGE_STORAGE_KEY = 'uo_language';

// Get stored language from localStorage
export const getStoredLanguage = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

// Save language to localStorage
export const saveLanguagePreference = (languageCode) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, languageCode);
  } catch {
    console.warn('Failed to save language preference');
  }
};

// Validate if language is supported
export const isSupportedLanguage = (languageCode) => 
  languageCode in SUPPORTED_LANGUAGES;
